import { BaseQueryDTO } from './basequery-dto';

export class QueryInternalCommentDTO extends BaseQueryDTO
{
    ProposalId: number;
}
